import React, {useState} from 'react';
import Button from './Button';
import myImage from '../assets/logo-new-blue.png';
import {Link} from 'react-router-dom'

const Nav = () => {
    let Links = [{name: "Work", link: "/work"}, {name: "Services", link: "/services"}, {
        name: "About", link: "/about"
    },];

    let [open, setOpen] = useState(false);

    return (<header className="bg-background p-6 w-full z-30 fixed top-0">
        <div className="container mx-auto">
            <div className="flex items-center justify-between">

                {/* Logo */}
                <div className="logo-container px-5">
                    <Link className="shrink-0" to='/'>
                        <img src={myImage} className="w-1/2" alt='Menu Icon'/>
                    </Link>
                </div>

                {/* Menu */}
                <div>
                    <div onClick={() => setOpen(!open)}
                         className="mr-2 text-5xl cursor-pointer md:hidden">
                        <ion-icon name={open ? 'close' : 'menu'}></ion-icon>
                    </div>
                    {/* {`pb-6 absolute top-20 items-center justify-center left-0 bg-green-50 w-full ${open ? 'flex z-[-1]' : 'hidden'}`} */}
                    <div
                        className={`md:flex md:static md:pb-0 md:pl-0 absolute pb-12 z-[-1] left-0 w-full pl-9 transition-opacity duration-500 ease-in-out ${open ? 'top-20 opacity-100' : 'top-[-490px] md:opacity-100 opacity-0'}`}>
                        <ul className="md:flex items-center">
                            {Links.map((link) => (<li key={link.name} className='md:pl-9 md:py-0 py-5 text-xl'>
                                    <a href={link.link}
                                       className='mx-5 text-gray-800 hover:text-gray-400 duration-500'>{link.name}</a>
                                </li>))}
                            <Button className="md:ml-10">
                                <Link to='/contact'>Contact Us</Link>
                            </Button>
                        </ul>
                    </div>

                </div>

            </div>

        </div>
    </header>)
}

export default Nav
